


















export default {
  name: 'StatsCard',
  props: ['name', 'value'],
};
